<script>
import { getCustomerBreakdown } from "./reporting-mock-data";
import toCurrency from "@/helpers/currency";

export default {
  name: "reporting-customer-chart",
  props: {
    periodType: {
      type: String,
      default: "month",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      customerData: [],
      chartOptions: {
        chart: {
          type: "bar",
          height: 350,
          toolbar: {
            show: true,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            distributed: false,
            dataLabels: {
              position: "top",
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: (value) => toCurrency(value),
          offsetX: 0,
          style: {
            fontSize: "11px",
            colors: ["#304758"],
          },
        },
        stroke: {
          show: true,
          width: 1,
          colors: ["#fff"],
        },
        xaxis: {
          categories: [],
          labels: {
            formatter: (value) => toCurrency(value),
          },
        },
        yaxis: {
          title: {
            text: "Customers",
          },
        },
        colors: ["#556ee6"],
        fill: {
          opacity: 0.9,
          type: "gradient",
          gradient: {
            shade: "light",
            type: "horizontal",
            shadeIntensity: 0.5,
            inverseColors: false,
            opacityFrom: 0.9,
            opacityTo: 0.7,
            stops: [0, 100],
          },
        },
        tooltip: {
          y: {
            formatter: (value) => toCurrency(value),
          },
        },
        grid: {
          borderColor: "#f1f1f1",
        },
        legend: {
          show: false,
        },
      },
      series: [],
    };
  },
  watch: {
    periodType: {
      handler: "loadData",
      immediate: true,
    },
  },
  methods: {
    loadData() {
      // Simulate API call with mock data
      this.customerData = getCustomerBreakdown(this.periodType);
      this.updateChart();
    },
    updateChart() {
      // Sort by revenue and take top 8
      const topCustomers = this.customerData
        .sort((a, b) => b.revenue - a.revenue)
        .slice(0, 8);

      // Prepare categories (customer names)
      const categories = topCustomers.map((item) => item.customerName);

      // Prepare series data
      const revenueData = topCustomers.map(
        (item) => Math.round(item.revenue * 100) / 100
      );

      // Update chart
      this.chartOptions = {
        ...this.chartOptions,
        xaxis: {
          ...this.chartOptions.xaxis,
          categories: categories,
        },
      };

      this.series = [
        {
          name: "Revenue",
          data: revenueData,
        },
      ];
    },
  },
};
</script>

<template>
  <b-card no-body>
    <b-card-body>
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h4 class="card-title mb-0">Top Customers by Revenue</h4>
        <div>
          <i class="bx bx-user text-success font-size-20"></i>
        </div>
      </div>

      <div v-if="isLoading" class="text-center py-5">
        <b-spinner variant="success" label="Loading..."></b-spinner>
        <p class="text-muted mt-2">Loading chart data...</p>
      </div>

      <div v-else>
        <apexchart
          type="bar"
          height="350"
          :options="chartOptions"
          :series="series"
        ></apexchart>
      </div>
    </b-card-body>
  </b-card>
</template>

<style scoped>
.card-title {
  font-size: 1.1rem;
  font-weight: 600;
}
</style>
